export default {
  // Navigation
  nav: {
    about: 'About',
    services: 'Services',
    portfolio: 'Portfolio',
    blog: 'Blog',
    careers: 'Careers',
    plans: 'Plans',
    contact: 'Let\'s Talk',
    home: 'Home'
  },

  // Hero Section
  hero: {
    welcome: 'WELCOME TO RADIX',
    title: 'We\'re an ',
    title_1: ' that delivers.',
    titleHighlight: 'AI-driven development Company',
    description: 'We build smarter, faster, and more cost-effective digital solutions. Trusted by multinational clients like Dell, Cloudify, Envoy America, and Sales Script, we transform visionary ideas into scalable, high-quality products on time and within budget.',
    statsLabel: 'With over',
    statsNumber: '10 years',
    statsDescription: 'of market experience, our expert team combines deep technical knowledge with tailored strategies across AI, IT services, cloud, mobile applications, and outsourcing. backed by 24/7 support, global reach, and seamless scalability.',
    cta: 'Contact Us',
    learnMore: 'Our Services',
    quickAccess: 'Quick Access:',
  },

  // Partners Section
  partners: {
    title: 'Our Clients',
    subtitle: 'Trusted by leading companies worldwide'
  },

  // Why Trust Us Section
  whyTrustUs: {
    title: 'We care about what our clients think',
    subtitle: 'Our operational approach revolves around two distinct yet interconnected methodologies that cater to the unique needs of our clients: Dedicated Team Model & Team Building, along with Project-Based engagement. We ensure professionalism throughout every project.',
    stats: {
      projects: '164+ successful projects delivered with excellence and precision.',
      experience: '19+ years of experience in IT service delivery and cloud solutions.',
      team: 'Dedicated team of highly skilled experts working exclusively on your project.',
      support: '24/7 support with seamless scalability and global reach.',
      agile: 'Agile development practices leading to better deliverables and user satisfaction.'
    }
  },

  // Services
  services: {
    title: 'How we can help',
    pageTitle: 'Our Services',
    pageDescription: 'Comprehensive technology solutions designed to accelerate your business growth and digital transformation journey.',
    processTitle: 'Our Process',
    ctaTitle: 'Ready to Get Started?',
    ctaDescription: 'Let\'s discuss your project requirements and find the perfect solution for your needs.',
    startProject: 'Start Your Project',
    viewWork: 'View Our Work',
    getStarted: 'Get Started',
    whatsIncluded: 'What\'s Included:',
    technologies: 'Technologies:',
    aiSolutions: {
      title: 'AI Solutions',
      description: 'At Radix Technologies, we harness the power of Artificial Intelligence and Machine Learning to transform raw data into actionable insights. Our AI services include predictive analytics, natural language processing, computer vision, and intelligent automation.',
      features: [
        'Machine Learning Models',
        'Natural Language Processing',
        'Computer Vision',
        'Predictive Analytics',
        'AI Integration & Deployment',
        'Model Optimization & Monitoring'
      ],
      technologies: ['TensorFlow', 'PyTorch', 'OpenAI', 'Hugging Face', 'Python', 'MLOps']
    },
    cloudDeployment: {
      title: 'Cloud Deployment & Migration',
      description: 'Let us facilitate a smooth cloud migration journey. Our experts help you leverage cloud technologies for scalability, cost optimization, and enhanced performance across AWS, Azure, and Google Cloud.',
      features: [
        'Cloud Architecture Design',
        'Migration Planning & Execution',
        'Multi-Cloud Strategy',
        'Cost Optimization',
        'Security Implementation',
        'Performance Monitoring'
      ],
      technologies: ['AWS', 'Azure', 'GCP', 'Docker', 'Kubernetes', 'Terraform']
    },
    mobileDevelopment: {
      title: 'Mobile Development',
      description: '19+ years of experience in native mobile app development. Our engineers create high-performance iOS and Android applications that deliver exceptional user experiences.',
      features: [
        'iOS & Android Development',
        'Cross-Platform Solutions',
        'App Store Optimization',
        'Push Notifications',
        'Offline Functionality',
        'App Analytics Integration'
      ],
      technologies: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Xamarin', 'Ionic']
    },
    devOps: {
      title: 'DevOps & Automation',
      description: 'Optimize your software delivery pipeline with our comprehensive DevOps solutions. We implement CI/CD practices, infrastructure automation, and monitoring systems to accelerate your development lifecycle.',
      features: [
        'CI/CD Pipeline Setup',
        'Infrastructure as Code',
        'Monitoring & Logging',
        'Security Implementation',
        'Performance Optimization',
        'Automated Testing'
      ],
      technologies: ['Jenkins', 'GitLab CI', 'Docker', 'Kubernetes', 'Ansible', 'Prometheus']
    },
    managedServices: {
      title: 'Managed Services',
      description: 'Given the emphasis on innovation and swift delivery, our managed services ensure your infrastructure runs smoothly while you focus on core business objectives.',
      features: [
        '24/7 Infrastructure Monitoring',
        'Proactive Maintenance',
        'Security Management',
        'Backup & Disaster Recovery',
        'Performance Optimization',
        'Technical Support'
      ],
      technologies: ['AWS', 'Azure', 'Monitoring Tools', 'Security Tools', 'Backup Solutions']
    },
    qualityAssurance: {
      title: 'Quality Assurance',
      description: 'We guarantee product quality and expedited software release cycles through comprehensive testing strategies, automated testing frameworks, and continuous quality monitoring.',
      features: [
        'Automated Testing Frameworks',
        'Manual Testing Services',
        'Performance Testing',
        'Security Testing',
        'User Acceptance Testing',
        'Continuous Quality Monitoring'
      ],
      technologies: ['Selenium', 'Jest', 'Cypress', 'JMeter', 'Postman', 'TestRail']
    },
    process: {
      discovery: {
        step: '01',
        title: 'Discovery',
        description: 'We start by understanding your business goals, technical requirements, and project constraints.'
      },
      planning: {
        step: '02',
        title: 'Planning',
        description: 'Our team creates a detailed project roadmap with milestones, timelines, and resource allocation.'
      },
      development: {
        step: '03',
        title: 'Development',
        description: 'We execute the plan using agile methodologies, ensuring regular communication and feedback.'
      },
      delivery: {
        step: '04',
        title: 'Delivery',
        description: 'We deploy your solution and provide comprehensive documentation and training.'
      },
      support: {
        step: '05',
        title: 'Support',
        description: 'Ongoing maintenance, updates, and support to ensure your solution continues to perform.'
      }
    }
  },

  // Blog
  blog: {
    pageTitle: 'Radix Technologies Blog',
    pageDescription: 'Practical insights on software delivery, cloud migration, DevOps, AI development, and product strategy.',
    heroEyebrow: 'Insights and field notes',
    heroTitle: 'What we are learning while building modern software',
    heroDescription: 'We publish concise, practical articles that reflect the problems we solve for clients every day. Expect actionable guidance on delivery, architecture, performance, and operating software at scale.',
    featuredTitle: 'Featured articles',
    featuredArticles: {
      delivery: {
        title: 'How to ship software without losing quality',
        excerpt: 'A repeatable delivery model for teams that need speed, stability, and measurable progress.',
        category: 'Delivery',
        readTime: '6 min read'
      },
      cloud: {
        title: 'Cloud migration decisions that actually reduce risk',
        excerpt: 'The planning checkpoints we use before moving systems to AWS, Azure, or GCP.',
        category: 'Cloud',
        readTime: '5 min read'
      },
      ai: {
        title: 'Where AI belongs in a product roadmap',
        excerpt: 'A practical guide for choosing between automation, machine learning, and full AI workflows.',
        category: 'AI Strategy',
        readTime: '4 min read'
      }
    },
    editorialTitle: 'What this blog covers',
    editorialItems: [
      'Delivery playbooks for startups and enterprise teams',
      'Cloud, DevOps, and reliability lessons from production systems',
      'Architecture choices, tradeoffs, and implementation patterns',
      'AI use cases that create value instead of noise'
    ],
    ctaTitle: 'Need advice on a project?',
    ctaDescription: 'If a topic on the blog mirrors your current challenge, talk to us and we will help you turn it into a delivery plan.',
    ctaButton: 'Contact us'
  },

  // Plans/Engagement Models
  plans: {
    title: 'Our Engagement Models',
    projectBased: {
      title: 'Project-Based',
      subtitle: 'Engagement',
      description1: 'Fixed scope and timeline projects',
      description2: 'You pay for the time and material involved',
      description3: 'Complete project delivery with defined outcomes',
      features: {
        team: 'Dedicated project team',
        manager: 'Project manager',
        qa: 'Quality assurance',
        documentation: 'Documentation and training',
        support: 'Post-delivery support'
      }
    },
    dedicatedTeam: {
      title: 'Dedicated Team',
      subtitle: 'Model',
      popular: 'POPULAR',
      description1: 'Team of IT engineers exclusively working on your project/product',
      description2: 'Scale your development capabilities',
      description3: 'Long-term partnership with consistent team members',
      features: {
        developers: 'Dedicated developers',
        devops: 'DevOps engineers',
        qa: 'QA specialists',
        lead: 'Technical lead',
        support: '24/7 support'
      }
    },
    managedServices: {
      title: 'Managed Services',
      subtitle: 'Support',
      description1: '24/7 infrastructure monitoring and support',
      description2: 'Focus on core business while we handle IT operations',
      description3: 'Proactive maintenance and issue resolution',
      managementTitle: 'Complete IT operations management:',
      features: {
        monitoring: 'Infrastructure monitoring',
        security: 'Security management',
        backup: 'Backup and disaster recovery',
        optimization: 'Performance optimization',
        maintenance: 'Regular maintenance and updates'
      }
    },
    contactUs: 'Contact us',
    pageTitle: 'Choose Your Plan',
    pageDescription: 'Flexible engagement models designed to meet your specific needs and budget. From MVP development to full-scale R&D teams, we have the right solution for you.',
    comparisonTitle: 'Plan Comparison',
    testimonialsTitle: 'What Our Clients Say',
    faqTitle: 'Frequently Asked Questions',
    ctaTitle: 'Ready to Get Started?',
    ctaDescription: 'Schedule a free consultation to discuss your project requirements and find the perfect plan for your needs.',
    scheduleConsultation: 'Schedule Consultation',
    viewOurWork: 'View Our Work',
    comparison: {
      features: 'Features',
      startupMvp: 'Startup MVP',
      engagement: 'Engagement',
      professional: 'Professional',
      custom: 'Custom',
      fullStackDev: 'Full-stack Development',
      projectManagement: 'Project Management',
      devOpsInfra: 'DevOps & Infrastructure',
      uxUiDesign: 'UX/UI Design',
      aiMlIntegration: 'AI/ML Integration',
      dedicatedTeam: 'Dedicated Team',
      support247: '24/7 Support',
      basic: 'Basic',
      optional: 'Optional',
      businessHours: 'Business Hours'
    },
    faqs: {
      choosePlan: {
        question: 'How do I choose the right plan for my startup?',
        answer: 'We recommend starting with a consultation call to understand your specific needs, timeline, and budget. Our Startup MVP package is perfect for early-stage companies, while the Engagement package works well for scaling businesses.'
      },
      switchPlans: {
        question: 'Can I switch between plans during the project?',
        answer: 'Yes, we offer flexible arrangements. As your needs evolve, we can adjust the scope and team composition to match your requirements. We believe in growing with our clients.'
      },
      rdService: {
        question: 'What is included in the R&D as a Service?',
        answer: 'Our R&D service includes everything from initial product strategy and design to development, testing, deployment, and ongoing maintenance. We act as your complete technical team.'
      },
      international: {
        question: 'Do you work with international clients?',
        answer: 'Absolutely! We work with clients globally and have experience with different time zones, regulatory requirements, and business practices. Our remote-first approach makes international collaboration seamless.'
      },
      technologies: {
        question: 'What technologies do you specialize in?',
        answer: 'We specialize in modern web and mobile technologies including React, Node.js, Python, cloud platforms (AWS, Azure, GCP), AI/ML frameworks, and DevOps tools. We stay current with the latest industry trends.'
      },
      quality: {
        question: 'How do you ensure project quality and timeline adherence?',
        answer: 'We use agile methodologies with regular sprints, daily standups, and weekly reviews. Our project managers provide transparent reporting, and we maintain high code quality through peer reviews and automated testing.'
      }
    },
    testimonials: {
      ad: {
        name: 'A.D.',
        company: 'Cloudify.co (acquired by Dell)',
        role: 'CEO',
        content: 'Outsourcing PS and software development is always a challenge and it therefore gives me great pleasure to recommend Radix as a company I trust and appreciate. Radix constantly goes above and beyond in ensuring an on-time successful delivery of projects and Adel is a professional and trusted leader who keeps a positive attitude and a smile during stressful situations or tight schedules.'
      },
      de: {
        name: 'D.E',
        company: ' ',
        role: 'Director of Engineering',
        content: 'I\'ve been working with Radix, that is led By Adel, which gave us mobile (native iOS and Android) development services- they worked with my mobile teams as integrated part of them with collaboration on the same projects.'
      },
      assaf: {
        name: 'Assaf.L',
        company: 'Public Sector EMEA',
        role: 'Head of Technical Account Management',
        content: 'I had the pleasure working with Adel for the last 2 years. As VP of CS, I worked with engineers from Adel company, providing a wide range of services and implementations to our customers.'
      },
      gh: {
        name: 'G.H',
        company: 'IPCC and Industry',
        role: 'CEO',
        content: 'Radix and I are partnered on several projects from 2016 till now, Adel is managing Radix Technologies in Nablus, they provide us Software Development services. I found Adel and Radix Technologies extremely professional, very committed and highly responsive.'
      },
      js: {
        name: 'J.S',
        company: 'Envoy America',
        role: 'COO',
        content: 'I am pleased to recommend Adel Joudallah and Radix Technologies for their exceptional work developing and maintaining our rideshare and company vehicles management system\'s IT infrastructure. Radix Technologies consistently delivers high-quality, cost-effective solutions that meet our stringent requirements. Their attention to detail, commitment to excellence, and proficiency in various technologies, from mobile app development to backend systems, have been instrumental in our success.'
      }
    }
  },

  // Portfolio
  portfolio: {
    title: 'Our Portfolio',
    subtitle: 'Showcasing Our Work',
    insights: 'Project insights',
    filterBy: 'Filter by',
    clearFilter: 'Clear filter',
    country: 'Country',
    industry: 'Industry',
    readyTitle: 'Ready to Start Your Project?',
    readyDescription: 'Let\'s create something amazing together. Get in touch to discuss your next project.',
    startProject: 'Start Your Project',
    // Modal content
    projectOverview: 'Project Overview',
    servicesProvided: 'Services Provided',
    technologiesUsed: 'Technologies Used',
    keyResults: 'Key Results',
    client: 'Client',
    timeline: 'Timeline',
    // Projects data
    projects: {
      cloudify: {
        title: 'Cloudify Platform',
        industry: 'Cloud',
        country: 'New York, United States',
        description: 'Enterprise cloud orchestration platform that was successfully acquired by Dell Technologies. Comprehensive DevOps automation and cloud management solution providing scalable infrastructure management across multi-cloud environments.',
        longDescription: 'Cloudify is a comprehensive cloud orchestration platform that enables enterprises to deploy, manage, and scale applications across multi-cloud environments. Our team provided extensive development and DevOps support throughout the platform evolution.',
        client: 'Cloudify (Acquired by Dell)',
        timeline: '24 months',
        services: ['Backend', 'DevOps', 'Cloud Architecture', 'Automation'],
        technologies: ['Python', 'Docker', 'Kubernetes', 'AWS', 'Azure'],
        results: ['Acquired by Dell', 'Enterprise Scale', '99.9% Uptime']
      },
      earlysense: {
        title: 'EarlySense Platform',
        industry: 'Healthcare',
        country: 'Massachusetts, United States',
        description: 'Advanced healthcare monitoring platform providing continuous patient monitoring and early warning systems for hospitals and healthcare facilities worldwide.',
        longDescription: 'EarlySense revolutionizes patient care through contactless monitoring technology. Our team developed scalable backend systems and real-time analytics to support critical healthcare operations.',
        client: 'EarlySense Healthcare',
        timeline: '18 months',
        services: ['Backend', 'DevOps', 'Data Analytics', 'Real-time Systems'],
        technologies: ['Java', 'Spring', 'Apache Kafka', 'PostgreSQL', 'AWS'],
        results: ['Hospital Integration', 'Real-time Monitoring', 'Patient Safety']
      },
      dell: {
        title: 'Dell Technologies',
        industry: 'Enterprise',
        country: 'New York, United States',
        description: 'Enterprise technology solutions and infrastructure management platform providing comprehensive IT services and support for global enterprise clients.',
        longDescription: 'Dell Technologies enterprise solutions that streamline IT operations, automate infrastructure provisioning, and provide comprehensive monitoring and support capabilities for large-scale enterprise clients.',
        client: 'Dell Technologies',
        timeline: '36 months',
        services: ['Enterprise Solutions', 'Infrastructure', 'Support', 'Integration'],
        technologies: ['Enterprise Software', 'Cloud', 'Infrastructure', 'Security'],
        results: ['Enterprise Scale', '99.9% Uptime', 'Global Deployment']
      },
      envoy: {
        title: 'Envoy America Companion',
        industry: 'Mobile',
        country: 'Arizona, United States',
        description: 'Comprehensive caregiving platform connecting professional caregivers with those in need of companionship and support services through innovative mobile technology.',
        longDescription: 'Envoy America Companion connects caregivers with those in need of companionship and support services. Our comprehensive mobile and web platform facilitates meaningful connections and professional caregiving services.',
        client: 'Envoy America',
        timeline: '24 months',
        services: ['Frontend', 'Backend', 'Mobile App', 'DevOps'],
        technologies: ['Angular', 'Swift', 'Kotlin', 'Firebase', 'Django', 'GCP'],
        results: ['100K+ Users', '2M+ Connections', '85% Daily Engagement']
      },
      geofree: {
        title: 'GeoFree Software',
        industry: 'Enterprise',
        country: '',
        description: 'Advanced geospatial software solutions for mapping, analysis, and location-based services with cutting-edge GIS technology for enterprise clients.',
        longDescription: 'GeoFree Software provides comprehensive geospatial solutions including mapping, spatial analysis, and location intelligence. Our platform serves enterprises with advanced GIS capabilities and real-time geographic data processing.',
        client: 'GeoFree Software',
        timeline: '18 months',
        services: ['Backend', 'Frontend', 'GIS Development', 'Data Analytics'],
        technologies: ['React', 'Node.js', 'PostgreSQL', 'PostGIS', 'MapBox'],
        results: ['50+ Enterprise Clients', 'Real-time Processing', 'Global Coverage']
      },
      moretech: {
        title: 'MoreTech E-Commerce',
        industry: 'E-Commerce',
        country: 'Palestine',
        description: 'Intelligent eCommerce solution that resolves lost revenue mysteries and drives online sales performance with advanced analytics and optimization tools.',
        longDescription: 'MoreTech provides comprehensive e-commerce solutions featuring advanced analytics, inventory management, customer insights, and sales optimization tools for online retailers.',
        client: 'MoreTech',
        timeline: '14 months',
        services: ['Backend', 'Frontend', 'Analytics', 'E-Commerce'],
        technologies: ['Angular', 'Django', 'DigitalOcean', 'Analytics', 'Payment Systems'],
        results: ['300% Sales Increase', '99.9% Uptime', 'Multi-platform']
      },
      s2cript: {
        title: 'S2cript Sales Management Platform',
        industry: 'Sales & Marketing',
        country: 'Netherlands',
        description: 'Comprehensive sales management platform for IVD (In Vitro Diagnostics) manufacturers and distributors, providing product training, sales support materials, and distributor portal solutions.',
        longDescription: 'S2cript B.V. specializes in international sales management of IVD products, offering comprehensive solutions for manufacturers to train their sales representatives and distributors. The platform provides product guides, training materials, and portal access to support effective sales processes in the medical diagnostics industry.',
        client: 'S2cript B.V.',
        timeline: '18 months',
        services: ['Web Development', 'Portal Development', 'Training Systems', 'Sales Support'],
        technologies: ['ASP.NET', 'Angular', 'C#', 'SQL Server', 'Azure'],
        results: ['Enhanced Sales Training', 'Improved Product Knowledge', 'Streamlined Distribution']
      },
      itmyway: {
        title: 'ItMyWay Digital Solutions',
        industry: 'Digital Transformation',
        country: 'United States',
        description: 'Custom digital transformation solutions helping businesses modernize their operations and improve customer engagement through innovative technology.',
        longDescription: 'ItMyWay provides comprehensive digital transformation services, helping businesses modernize their operations, streamline processes, and enhance customer engagement through cutting-edge technology solutions.',
        client: 'ItMyWay',
        timeline: '20 months',
        services: ['Digital Transformation', 'Custom Development', 'Integration', 'Consulting'],
        technologies: ['React', 'Node.js', 'MongoDB', 'AWS', 'Docker'],
        results: ['50% Process Efficiency', 'Digital Modernization', 'Enhanced User Experience']
      },
      inventionland: {
        title: 'Invention Land Innovation Hub',
        industry: 'Innovation Platform',
        country: 'United States',
        description: 'Creative product development platform connecting inventors with manufacturers through innovative digital solutions and marketplace functionality.',
        longDescription: 'Invention Land provides a comprehensive innovation platform that connects inventors with manufacturers, featuring product development tools, marketplace functionality, and collaboration features for the innovation community.',
        client: 'Invention Land',
        timeline: '16 months',
        services: ['Product Development', 'E-commerce', 'Marketplace', 'Mobile App'],
        technologies: ['React Native', 'Django', 'PostgreSQL', 'Stripe API'],
        results: ['1000+ Inventors', 'Product Marketplace', 'Innovation Network']
      },
      cloudytech: {
        title: 'Cloudy Tech Solutions',
        industry: 'Cloud Services',
        country: 'United States',
        description: 'Comprehensive cloud migration and optimization services with focus on cost reduction and performance enhancement for enterprise clients.',
        longDescription: 'Cloudy Tech specializes in cloud migration, optimization, and management services, helping enterprises reduce costs while improving performance and scalability across multi-cloud environments.',
        client: 'Cloudy Tech',
        timeline: '22 months',
        services: ['Cloud Migration', 'Cost Optimization', 'Performance Tuning', 'Security'],
        technologies: ['AWS', 'Azure', 'GCP', 'Terraform', 'Monitoring Tools'],
        results: ['40% Cost Reduction', 'Cloud Migration', 'Performance Optimization']
      },
      goto: {
        title: 'GoTo Communication Platform',
        industry: 'Communication Technology',
        country: 'United States',
        description: 'Unified communication and collaboration platform enabling seamless remote work and team productivity with advanced video conferencing capabilities.',
        longDescription: 'GoTo provides a comprehensive communication platform featuring video conferencing, team collaboration tools, and productivity features designed for modern remote and hybrid work environments.',
        client: 'GoTo',
        timeline: '24 months',
        services: ['Communication Platform', 'Video Conferencing', 'Collaboration Tools', 'Mobile'],
        technologies: ['WebRTC', 'React', 'Node.js', 'Socket.io', 'Redis'],
        results: ['10M+ Users', 'Global Platform', 'Enterprise Integration']
      },
      acumatica: {
        title: 'Acumatica ERP Integration',
        industry: 'Enterprise Software',
        country: 'United States',
        description: 'Enterprise resource planning system with advanced integration capabilities and custom business process automation for large organizations.',
        longDescription: 'Acumatica ERP solution featuring comprehensive business process automation, advanced integration capabilities, and custom modules designed for enterprise-scale operations and workflow optimization.',
        client: 'Acumatica',
        timeline: '30 months',
        services: ['ERP Development', 'System Integration', 'Business Automation', 'Custom Modules'],
        technologies: ['C#', '.NET', 'SQL Server', 'REST APIs', 'Azure'],
        results: ['Enterprise Scale', 'Process Automation', 'System Integration']
      },
      innovo: {
        title: 'Innovo Innovation Platform',
        industry: 'Innovation Management',
        country: 'United States',
        description: 'Next-generation innovation management platform facilitating idea generation, collaboration, and project execution for enterprise innovation teams.',
        longDescription: 'Innovo provides a comprehensive innovation management platform that enables organizations to capture ideas, facilitate collaboration, manage innovation projects, and track innovation metrics across the enterprise.',
        client: 'Innovo',
        timeline: '18 months',
        services: ['Innovation Management', 'Collaboration Platform', 'Project Management', 'Analytics'],
        technologies: ['Vue.js', 'Laravel', 'MySQL', 'Docker', 'AWS'],
        results: ['Innovation Pipeline', 'Collaboration Tools', 'Project Tracking']
      },
      eddiebauer: {
        title: 'Eddie Bauer E-commerce',
        industry: 'Retail E-commerce',
        country: 'United States',
        description: 'Modern e-commerce platform with advanced inventory management, personalization, and omnichannel capabilities for retail operations.',
        longDescription: 'Eddie Bauer e-commerce solution featuring advanced inventory management, personalized shopping experiences, omnichannel integration, and comprehensive retail analytics for enhanced customer engagement.',
        client: 'Eddie Bauer',
        timeline: '26 months',
        services: ['E-commerce Development', 'Inventory Management', 'Personalization', 'Mobile Commerce'],
        technologies: ['Shopify Plus', 'React', 'Node.js', 'GraphQL', 'Elasticsearch'],
        results: ['Omnichannel Experience', 'Inventory Optimization', 'Customer Personalization']
      },
      hamdan: {
        title: 'Hamdan Center Management System',
        industry: 'Healthcare Management',
        country: 'United Arab Emirates',
        description: 'Comprehensive facility management system for healthcare centers with patient scheduling and resource optimization capabilities.',
        longDescription: 'Hamdan Center management system provides comprehensive healthcare facility management including patient scheduling, resource planning, staff coordination, and operational optimization for healthcare centers.',
        client: 'Hamdan Center',
        timeline: '20 months',
        services: ['Healthcare Management', 'Scheduling System', 'Resource Planning', 'Patient Portal'],
        technologies: ['Angular', 'Spring Boot', 'PostgreSQL', 'Docker', 'Kubernetes'],
        results: ['Healthcare Efficiency', 'Patient Management', 'Resource Optimization']
      },
      logsios: {
        title: 'Logsios Analytics Platform',
        industry: 'Analytics & Monitoring',
        country: 'United States',
        description: 'Advanced log analytics and monitoring platform providing real-time insights and predictive analytics for IT operations and system monitoring.',
        longDescription: 'Logsios provides comprehensive log analytics and monitoring solutions featuring real-time data processing, predictive analytics, alerting systems, and operational intelligence for IT infrastructure management.',
        client: 'Logsios',
        timeline: '22 months',
        services: ['Log Analytics', 'Real-time Monitoring', 'Predictive Analytics', 'DevOps Tools'],
        technologies: ['Elasticsearch', 'Kibana', 'Python', 'Apache Kafka', 'Docker'],
        results: ['Real-time Analytics', 'Predictive Insights', 'System Monitoring']
      },
      pixelpurehat: {
        title: 'PixelPureHat Performance Marketing',
        industry: 'Sales & Marketing',
        country: '',
        description: 'Performance-driven advertising partner delivering scalable digital campaigns across native advertising, programmatic media, content, e-commerce, and lead generation.',
        longDescription: 'PixelPureHat helps brands grow through data-driven advertising and creative strategy. Its services span app growth, content marketing, performance marketing, e-commerce campaigns, B2B lead generation, video advertising, native advertising, and programmatic media.',
        client: 'PixelPureHat',
        timeline: 'Ongoing partnership',
        services: ['Performance Marketing', 'Content Marketing', 'E-commerce Marketing', 'Lead Generation', 'Programmatic Advertising'],
        technologies: ['Digital Advertising', 'Native Ads', 'Programmatic Media', 'Analytics', 'SEO'],
        results: ['100K+ Campaigns', '500+ Clients Served', 'Performance-driven Growth']
      },
      adgptise: {
        title: 'adGPTise Publisher Intelligence Platform',
        industry: 'Enterprise',
        country: '',
        description: 'AI-powered publisher intelligence platform helping digital publications make content more useful, teams more informed, and advertising more relevant.',
        longDescription: 'adGPTise adds an intelligent layer to publisher content through AI-powered reader summaries, article context analysis, publisher intelligence, and privacy-conscious advertising relevance tools. The platform works with existing CMS workflows through a lightweight integration.',
        client: 'adGPTise',
        timeline: 'Ongoing partnership',
        services: ['AI Platform Development', 'Publisher Intelligence', 'Content Summarization', 'Contextual Advertising'],
        technologies: ['Artificial Intelligence', 'Natural Language Processing', 'Content Analytics', 'CMS Integration'],
        results: ['Reader Engagement', 'Context-aware Advertising', 'Privacy-conscious Insights']
      }
    }
  },

  // About Section
  about: {
    title: 'About Radix Technologies',
    subtitle: 'Excellence in IT Solutions',
    description: 'We are a leading technology company specializing in cloud solutions, software development, and IT outsourcing services.',
    experience: 'Years of Experience',
    projects: 'Completed Projects',
    clients: 'Happy Clients',
    teamMembers: 'Expert Team Members',
    pageTitle: 'About Radix Technologies',
    heroDescription: 'Your one-stop-shop for redefined excellence in IT Service Delivery, Cloud Solutions and Outsourcing. We are a team of highly skilled experts committed to delivering personalized services that align with your needs and goals.',
    storyTitle: 'Our Story',
    storyParagraph1: 'Founded with a vision to redefine excellence in IT service delivery, Radix Technologies has grown into a trusted partner for companies worldwide. With 19+ years of experience and 164+ successful projects, we specialize in cloud solutions, DevOps automation, and comprehensive IT outsourcing services.',
    storyParagraph2: 'As your trusted partner, we offer 24/7 support, seamless scalability, and a global reach, delivering an unparalleled cost/value proposition. Experience the power of collaboration and transparent communications as we work together to drive your business forward through innovative technology solutions.',
    valuesTitle: 'Our Values',
    teamTitle: 'Meet Our Team',
    ctaTitle: 'Ready to Work Together?',
    ctaDescription: 'Let\'s discuss how we can help accelerate your next project',
    getStarted: 'Get Started',
    values: {
      excellence: {
        title: 'Excellence',
        description: 'We strive for redefined excellence in IT service delivery and cloud solutions.'
      },
      partnership: {
        title: 'Partnership',
        description: 'We work as your trusted partner with 24/7 support and seamless scalability.'
      },
      globalReach: {
        title: 'Global Reach',
        description: 'We provide global reach with local expertise and transparent communications.'
      },
      trust: {
        title: 'Trust',
        description: 'We build lasting relationships through proven track record and professional delivery.'
      }
    },
    team: {
      ceo: {
        name: 'Adel Jodallah',
        role: 'CEO & Founder',
        description: 'Visionary leader with 19+ years in IT service delivery, specializing in cloud solutions and digital transformation strategies.'
      },
      cto: {
        name: 'Mai Abuthraa',
        role: 'CTO & Cloud Architect',
        description: 'Expert in cloud architecture and DevOps solutions with 12+ years experience in AWS, Azure, and Kubernetes implementations.'
      },
      dev: {
        name: 'Taymoor Qanadilou',
        role: 'Head of Development',
        description: 'Full-stack developer with expertise in React, Node.js, and Python. Leads our development team in delivering scalable solutions.'
      }
    },
    stats: {
      projects: '164+',
      projectsLabel: 'Projects Delivered',
      clients: '50+',
      clientsLabel: 'Happy Clients',
      experience: '19+',
      experienceLabel: 'Years Experience'
    }
  },

  // Careers
  careers: {
    title: 'Join Our Team',
    subtitle: 'Build Your Career with Us',
    description: 'We\'re always looking for talented individuals to join our growing team.',
    openPositions: ' Positions',
    applyNow: 'Apply Now',
    benefitsPerks: 'Benefits & Perks',
    workCulture: 'Work Culture',
    pageTitle: 'Join Our Team',
    pageDescription: 'Build the future of technology with a team of passionate innovators. We\'re always looking for talented individuals to join our growing family.',
    whyWorkTitle: 'Why Work With Us?',
    whyWorkParagraph1: 'At Radix Technologies, we believe that great products are built by great teams. We foster a culture of innovation, collaboration, and continuous learning where every team member can thrive and make a meaningful impact.',
    whyWorkParagraph2: 'Our remote-first approach allows us to work with the best talent globally while maintaining strong team bonds through regular virtual events, team building activities, and annual company retreats.',
    ourValues: 'Our Values',
    benefitsTitle: 'Benefits & Perks',
    openPositionsTitle: ' Positions',
    ctaTitle: 'Don\'t See Your Role?',
    ctaDescription: 'We\'re always interested in hearing from talented individuals. Send us your resume and let us know how you\'d like to contribute to our team.',
    getInTouch: 'Get In Touch',
    experience: 'Experience:',
    requirements: 'Requirements:',
    responsibilities: 'Responsibilities:',
    viewDetails: 'View Details',
    backToCareers: 'Back to Careers',
    aboutRole: 'About the Role',
    interested: 'Interested in this position?',
    applyPrompt: 'Send us your resume and a brief introduction.',
    shareJob: 'Share this Job',
    copyLink: 'Copy Link',
    positionNotFound: 'Position Not Found',
    positionNotFoundDesc: 'Sorry, the job opportunity you are looking for does not exist or has been closed.',
    positionFilled: 'Position Filled',
    positionFilledBadge: 'Hired',
    positionFilledMessage: 'This position has been filled. We are no longer accepting applications.',
    departments: {
      engineering: 'Engineering',
      design: 'Design',
      operations: 'Operations'
    },
    locations: {
      palestine: 'Palestine',
      remote: 'Remote'
    },
    types: {
      fullTime: 'Full-time',
      partTime: 'Part-time',
      contract: 'Contract'
    },
    jobs: {
      juniorGenAI: {
        title: 'Junior GenAI Engineer',
        description: 'We are selectively hiring Junior GenAI Engineers to contribute to the design and development of production-grade AI systems. You will work alongside engineers on LLM pipelines, agentic systems, and retrieval-based architectures. This role is designed for high-potential junior engineers who are eager to learn and grow across the GenAI stack, including backend development, data pipelines, and applied AI systems, under structured technical guidance.',
        requirements: [
          'Bachelor’s or Master’s degree in Computer Science, AI/ML, or a related field',
          '0–2 years of hands-on experience building applications (Python required; familiarity with JavaScript/TypeScript is a plus)',
          'Strong understanding of Python fundamentals, OOP, and working with virtual environments',
          'Basic understanding of APIs and how systems communicate'
        ],
        responsibilities: [
          'Contribute to the development of Retrieval-Augmented Generation (RAG) pipelines, including document chunking, embedding generation, and retrieval mechanisms',
          'Assist in building and improving AI agents and LLM-powered applications',
          'Work with LLM APIs and frameworks to implement features and integrate AI capabilities into applications',
          'Support the development of backend services and APIs (e.g., FastAPI) to serve AI workflows',
          'Participate in data pipeline tasks, including data preprocessing, cleaning, and basic augmentation',
          'Evaluate and debug LLM outputs, improving quality through prompt iteration and retrieval tuning',
          'Collaborate with the team to experiment with different models, prompts, and system configurations',
          'Prototype features, test ideas, and iterate quickly in a collaborative environment',
          'Contribute to data pipeline development, including data ingestion, preprocessing, cleaning, and transformation for LLM-based systems'
        ]
      },
      seniorAI: {
        title: 'Senior AI Engineer',
        description: 'Join our team as a Senior AI Engineer to lead the development of advanced AI solutions. You will be responsible for architecting complex systems and mentoring junior engineers.',
        requirements: [
          'Strong background in Machine Learning and Deep Learning',
          'Proficiency in Python and AI frameworks like PyTorch or TensorFlow',
          'Experience with productionizing AI models',
          'Excellent problem-solving and leadership skills'
        ],
        responsibilities: [
          'Design and implement scalable AI architectures',
          'Lead the development of core AI features',
          'Mentor and guide junior team members',
          'Stay updated with the latest AI research and trends'
        ]
      }
    },
    values: {
      innovation: {
        title: 'Innovation',
        description: 'We embrace new technologies and creative solutions'
      },
      collaboration: {
        title: 'Collaboration',
        description: 'We work together to achieve common goals'
      },
      excellence: {
        title: 'Excellence',
        description: 'We strive for the highest quality in everything we do'
      },
      growth: {
        title: 'Growth',
        description: 'We invest in our people and their professional development'
      }
    },
    benefits: {
      remote: {
        title: 'Remote-First Culture',
        description: 'Work from anywhere with flexible hours and work-life balance'
      },
      learning: {
        title: 'Learning & Development',
        description: 'Annual learning budget and conference attendance opportunities'
      },
      health: {
        title: 'Health & Wellness',
        description: 'Comprehensive health insurance and wellness programs'
      },
      salary: {
        title: 'Competitive Salary',
        description: 'Market-competitive salaries with performance bonuses'
      },
      timeOff: {
        title: 'Paid Time Off',
        description: 'Generous vacation policy and public holidays'
      },
      growth: {
        title: 'Growth Opportunities',
        description: 'Clear career progression paths and leadership opportunities'
      }
    }
  },

  // Contact
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in Touch',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    send: 'Send Message',
    address: 'Address',
    callUs: 'Call Us',
    emailUs: 'Email Us',
    homeTitle: 'Project Based or Dedicated Team',
    homeDescription: 'Our operational approach revolves around two distinct methodologies: Dedicated Team Model & Team Building, along with Project-Based engagement. Experience the power of collaboration and transparent communications.',
    contactUs: 'Contact Us',
    floatingContact: 'Contact us',
    pageTitle: 'Get In Touch',
    pageDescription: 'Ready to unlock the full potential of IT & Cloud Computing? Let\'s discuss how our 19+ years of experience and proven track record can help drive your business forward.',
    formTitle: 'Tell Us About Your Project',
    fullName: 'Full Name *',
    fullNamePlaceholder: 'Your full name',
    emailAddress: 'Email Address *',
    emailPlaceholder: 'your@email.com',
    company: 'Company',
    companyPlaceholder: 'Your company name',
    phoneNumber: 'Phone Number',
    phonePlaceholder: '+1 (555) 123-4567',
    serviceNeeded: 'Service Needed',
    selectService: 'Select a service',
    budgetRange: 'Budget Range',
    selectBudget: 'Select budget range',
    projectTimeline: 'Project Timeline',
    selectTimeline: 'Select timeline',
    projectDescription: 'Project Description *',
    projectPlaceholder: 'Tell us about your project, goals, and any specific requirements...',
    sendMessage: 'Send Message',
    contactInformation: 'Contact Information',
    followUs: 'Follow Us',
    quickResponse: 'Quick Response',
    responseDescription: 'We typically respond within 24 hours during business days',
    scheduleCallTitle: 'Prefer to Schedule a Call?',
    scheduleCallDescription: 'Book a free 30-minute consultation to discuss your project in detail.',
    scheduleCall: 'Schedule Call',
    contactInfo: {
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      businessHours: 'Business Hours',
      businessHoursValue: 'Sun-Thu: 9:00 - 17:00 EEST'
    },
    services: {
      devopsAutomation: 'DevOps & Automation',
      cloudSolutions: 'Cloud Deployment & Migration',
      managedServices: 'Managed Services',
      consulting: 'Technology Advisory',
      mobileDevelopment: 'Mobile Development',
      qualityAssurance: 'Quality Assurance',
      aiMlSolutions: 'AI/ML Solutions',
      webDevelopment: 'Web Development',
      customSolution: 'Custom Solution'
    },
    budgetRanges: {
      under10k: 'Under $10K',
      '10k25k': '$10K - $25K',
      '25k50k': '$25K - $50K',
      '50k100k': '$50K - $100K',
      over100k: '$100K+',
      discuss: 'Let\'s discuss'
    },
    timelines: {
      asap: 'ASAP',
      '1to3months': '1-3 months',
      '3to6months': '3-6 months',
      '6to12months': '6-12 months',
      over12months: '12+ months',
      flexible: 'Flexible/Ongoing'
    },
    validation: {
      nameRequired: 'Name is required',
      nameMinLength: 'Name must be at least 2 characters',
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email address',
      phoneInvalid: 'Please enter a valid phone number',
      messageRequired: 'Project description is required',
      messageMinLength: 'Description must be at least 10 characters',
      looksGood: 'Looks good!'
    },
    form: {
      sending: 'Sending...',
      tryAgain: 'Try Again',
      errorGeneral: 'An error occurred while sending your message. Please try again.',
      errorNetwork: 'Network connection error. Please check your internet connection and try again.',
      errorTimeout: 'Request timed out. Please try again.',
      errorUnexpected: 'An unexpected error occurred. Please try again or contact us directly.',
      rateLimitExceeded: 'Too many submissions. Please try again in {minutes} minutes.',
      formSubmissionFailed: 'Form submission failed. Please check the {field} field and try again.',
      formSubmissionFailedGeneral: 'Form submission failed. Please check the errors and try again.',
      networkErrorPreserved: 'Network error occurred. Form data has been preserved. Please try again.',
      dismissError: 'Dismiss error message and try again',
      successMessage: 'Thank you for your message! We\'ll get back to you within 24 hours.',
      successAnnouncement: 'Form submitted successfully. Thank you for your message.',
      referenceId: 'Reference ID:',
      whatHappensNext: 'What happens next:',
      confirmationEmail: 'You\'ll receive a confirmation email shortly',
      teamReview: 'Our team will review your inquiry within 24 hours',
      contactDiscuss: 'We\'ll contact you to discuss your project in detail',
      rateLimitWait: 'Rate limit exceeded. Please wait before trying again.',
      submissionFailedCheck: 'Form submission failed. Please check the {field} field and try again.',
      submissionFailedGeneral: 'Form submission failed. Please check the errors and try again.',
      networkErrorPreserved: 'Network error occurred. Form data has been preserved. Please try again.',
      retrySubmission: 'You can now try submitting again.',
      formSubmitting: 'Form is being submitted, please wait.'
    }
  },

  // Footer
  footer: {
    description: 'Be Our Next Quoted “Success”',
    quickLinks: 'Quick Links',
    services: 'Services',
    contact: 'Contact Info',
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    // Services links
    devopsAutomation: 'DevOps & Automation',
    cloudMigration: 'Cloud Migration',
    managedServices: 'Managed Services',
    technologyAdvisory: 'Technology Advisory',
    mobileDevelopment: 'Mobile Development',
    qualityAssurance: 'Quality Assurance',
    // Navigation links
    aboutUs: 'About Us',
    portfolio: 'Portfolio',
    blog: 'Blog',
    careers: 'Careers',
    pricing: 'Pricing',
    contactLink: 'Contact',
    ourTeam: 'Our Team',
    // Contact info
    location: 'West Bank, Palestine',
    workingHours: 'Sun-Thu: 9:00 AM - 5:00 PM EEST'
  },

  // Common
  common: {
    readMore: 'Read More',
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    contactUs: 'Contact Us',
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success!',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous'
  }
};
